'use strict';

var Consts = require('consts');
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');
var Device = require('models/devices');

var SettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/meter/settings'),

    getInputFields: function () {
        return {
            name: {},
            address: {},
        };
    },

    getUpdatedModel: function (form) {
        return {
            name: form.name,
            address: parseInt(form.address),
            type: form.type + (form.solvimus ? '_solvimus' : ''),
        };
    },

    getNewModel: function (form, parent_id) {
        return new Device.Model({
            parent: parseInt(parent_id) || 0,
            name: form.name,
            address: parseInt(form.address) || 0,
            type: form.type + (form.solvimus ? '_solvimus' : ''),
            category: Consts.Category.Meter,
        });
    },
});

module.exports = SettingsView;
